import {
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    createTheme,
    CssBaseline,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Slide,
    TextField,
    ThemeProvider,
    Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useFetchFacturaCats } from "../../hooks/useFetchFacturaCats";
import { getOneIn, putOneIn } from '../../services/crudCustom';
import { SelectCustom } from "../modules/ui/SelectCustom";
import Swal from "sweetalert2";
import { uploadFile } from "../../services/uploadFile";
import { renderToString } from 'react-dom/server';
import { sendEmail } from "../../services/sendEmail";
import { insertSolicitudFactura } from "../../services/insertSolicitudFactura";
import { setEmailBodyEduconConfirma } from "../../helpers/setEmailBodyEduconConfirma";
import { GroupRequiereInvoiceGlobal } from "../modules/ui/GroupRequiereInvoiceGlobal";



export const EduconConfirma = () => {

    // Hook que obtiene los parametros que se envian por la Url, en este caso el id
    let params = useParams();
    const { id } = params;

    const [falseID, setFalseID] = useState(false);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partPais: "",
        partEstado: "",
        tipoRegistro: "",
        datosAdicionales:{},
        claveProyecto: "",
        registroFecha: "",
        registroReferencia: "",
        requiereFactura: false,
        factNombre: "",
        factRFC: "",
        factCP: "",
        factUsoCFDI: "",
        factRegimenFiscal: "",
        factExtranjero: "",
        factExtPais: "",
        factExtNombre: "",
        factExtConcepto: "",
        factExtUsoCFDI: "",
        compPagoFecha: "",
        compPagoURLLabel: "",
        compPagoURL: "",
        fechaPago: ""
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        registroReferencia,
        requiereFactura,
        factNombre,
        factRFC,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,
        factExtPais,
        factExtNombre,
        factExtConcepto,
    } = formValues;

    // state para la forma de pago
    const [detalles, setDetalles] = useState({
        formaPago: "",
        importe: "",
    });
    const { importe, formaPago } = detalles;
    const handleDetallesChange = ({ target }) => {
        console.log(target.name, target.value);
        setDetalles({
            ...detalles,
            [target.name]: target.value,
        });
    };

    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };

    // Se ejecuta al cargarse la pagina y de acuerdo al _loading_ se muestra/oculta el dialog de "Cargando inf..."
    const { dataCDFIs, dataRFs } = useFetchFacturaCats();

    // state para el fileupload
    const [file, setFile] = useState({
        file: '',
    });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // Para el swich de "Requiere Factura"
    const [checked] = useState(false);

    // Se envia como parentCallback en el componente GroupRequiereInvoiceGlobal (sic)
    const handleInvoiceDataChanged = (target) => {
        const { value, name } = target;
        console.log(value, name);

        setFormValues({
            ...formValues,
            [name]: value,
        });

    }
    

    // state para indicar si el formulario esta enviandose o no
    const [sendingForm, setSendingForm] = useState(false);
    // Waiting Dialog
    const handleCloseSendingForm = (_, reason) => {
        if (reason !== 'backdropClick') {
            setSendingForm(false);
        }
    };

    // Procesamiento de la info
    const isDataProcessed = async() => {

        // Subir archivo
        const fileName = `${registroReferencia}_compPago.pdf`
        const resultUpload = await uploadFile({ file, fileName });

        console.log({ resultUpload });
        if (resultUpload.exito === 0) {
            return false;
        }

        const dataUploaded = resultUpload.data;
        // console.log(dataUploaded);
        
        formValues.compPagoURL = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${dataUploaded}`;

        /**
                 const datosAdObj = {
            tipoRegistroDocURL: `https://eventos.cibnor.mx/registro/apiServiciosSIARF/UploadFiles/${registroReferencia}_credencial.pdf`, 
            educonId: educonId, 
            educonInicio: educonInicio, 
            educonTitulo: educonTitulo, 
            educonResponsableId: educonResponsableId, 
            educonCorreo: educonCorreo, 
            educonModalidad: educonModalidad,
        };

        const datosAdStr = JSON.stringify(datosAdObj);

        formValues.datosAdicionales = datosAdStr;
         */

        const addData = formValues.datosAdicionales;
        console.log({ addData });
        let toccAddresses = formValues.datosAdicionales.educonCorreo;

        const datosAdStr = JSON.stringify(formValues.datosAdicionales);

        formValues.datosAdicionales = datosAdStr;

        // Actualizar en db
        const resultPutOneIn = await putOneIn({ table:'RegistrosEducon', values:formValues });
        console.log({ resultPutOneIn });
        if (resultPutOneIn.exito === 0) {
            return false;
        }

        // Mandar correo
        const urlArchivo = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${resultUpload.data}`;
        const msgbody = renderToString( setEmailBodyEduconConfirma({formValues, urlArchivo}) );
        
        // Si estas en produccion, agregale el correo del titular del evento
        const envAddress = process.env.REACT_APP_TOCC_EDUCON;
        console.log({ envAddress });

        // Si estas en prod, agregar ambos correos, en caso contrario, a ninguno
        toccAddresses = (envAddress.length > 0) ? `${envAddress}, ${toccAddresses}`: ``;
        console.log({ toccAddresses });

        // let toccAddresses = process.env.REACT_APP_TOCC_EDUCON;
        // (process.env.REACT_APP_TOCC_EDUCON !== '') && (toccAddresses += `, ${formValues.datosAdicionales.educonCorreo}`);
        
        const resultEmail = await sendEmail({
            "toemail": partCorreo,
            "subject": `[${registroReferencia} | Educon] Comprobante de pago`,
            "message": msgbody,
            "replyto": "educon@cibnor.mx",
            "tocc": toccAddresses,
            "tobcc": process.env.REACT_APP_TOBCC_FACTURACION,
        });
        console.log({ resultEmail });
        if (resultEmail.exito === 0) {
            return false;
        }


        /**
         * Este procedimiento sacarlo a un nuevo service y
         * estructurarlo para poder reutilizarlo en cualquier otro evento
        */
       
       // Se establece el cliente a facturar dependiendo si pide o no factura
        let clientValues = {};
        if (requiereFactura === 'No') {
            // Obtenemos el cliente de publico en general
            const resultGetClient = await getOneIn({ table:'CatalogoClientes', id:'3' });
            const resultData = resultGetClient.data[0];

            clientValues = {
                clienteID: resultData.clienteID,
                codigoPostal: resultData.codigoPostal,
                email: resultData.email,
                nombreCliente: `${partNombres} ${partApellidoPaterno} ${partApellidoMaterno}`,
                // nombreCliente: resultData.nombreCliente,
                numeroCliente: resultData.numeroCliente,
                regimenFiscal: '616',
                rfcCliente: resultData.rfcCliente,
                usoCFDI: 'G03',
            }
            
        } else if (requiereFactura === 'Si') {
            // Si, nacional
            clientValues = {
                clienteID: 0,
                codigoPostal: formValues.factCP,
                email: formValues.partCorreo,
                nombreCliente: formValues.factNombre,
                numeroCliente: 0,
                regimenFiscal: formValues.factRegimenFiscal,
                rfcCliente: formValues.factRFC,
                usoCFDI: formValues.factUsoCFDI,
            }
        } else {
            // Si, extranjero
            const resultGetClient = await getOneIn({ table:'CatalogoClientes', id:'2' });
            const resultData = resultGetClient.data[0];
            console.log(resultData);

            clientValues = {
                clienteID: resultData.clienteID,
                codigoPostal: resultData.codigoPostal,
                concepto: formValues.factExtConcepto,
                email: formValues.partCorreo,
                nombreCliente: formValues.factExtNombre,
                numeroCliente: resultData.numeroCliente,
                regimenFiscal: '616',
                pais: formValues.factExtPais,
                rfcCliente: resultData.rfcCliente,
                usoCFDI: 'G03',
            }
        }
        // console.log({ clientValues });

        // Adaptar -values- con -clientValues-
        const values = {
            archivoPDF: urlArchivo,
            codigoPostal: clientValues.codigoPostal,
            correoElectronico: clientValues.email,            
            correoEvento: "educon@cibnor.mx",
            ejercicio: moment().format("YYYY"),
            envioSolicitud: "posgrado",
            fecha: formValues.compPagoFecha,
            formaPago: detalles.formaPago,
            importe: importe,
            nombreCliente: clientValues.nombreCliente,
            NumeroRegistro: formValues.registroReferencia,
            proyecto: formValues.claveProyecto,
            quienRegistro: addData.educonResponsableId,
            regimenFiscalID: clientValues.regimenFiscal,
            rfcCliente: clientValues.rfcCliente,
            solicitanteID: addData.educonResponsableId,
            telefonoCliente: null,
            usoCFDI: clientValues.usoCFDI,
        };
        console.log(values);

        // Se solicita la insercion de solicitud de factura con los datos necesarios
        const resultInsert = await insertSolicitudFactura(values);
        console.log(resultInsert);

        return true;
    }

    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        // Mostrar waiting dialog
        setSendingForm(true);
        
        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 
        
        // Ocultar waiting dialog
        setSendingForm(false);

        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más cursos de educación continua',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente.",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/posgrados/educacion-continua');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 

            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": "[Educon] Error",
                "message": formValues,
            });
        }
    }

    // Validar el formumario
    const isFormValid = () => {

        // console.log( formValues );

        // No ha indicado si requiere o no factura
        if (requiereFactura === false || requiereFactura === "") {
            Swal.fire("Indicar si requiere factura.", `Los campos marcados con [ * ] son obligatorios.`, "error");
            return false;
        }

        // Si requiere factura nacional
        if (requiereFactura === "Si") {

            // Preguntar si estan capturados los campos de factura nacional
            if ( [ factNombre, factRFC, factCP, factUsoCFDI, factRegimenFiscal ].includes("") ) {
                Swal.fire("Datos para facturar incompletos.", "Los campos marcados con [ * ] son obligatorios.", "error");
                return false;
            }
        }

        // Si requiere factura ext
        if (requiereFactura === "SiExt") {

            // Preguntar si estan capturados los campos de factura ext
            // if ( [ factExtPais, factExtNombre, factExtConcepto ].includes("") ) {
            if ( [ factExtPais, factExtNombre, factExtConcepto ].includes("") || [ factExtPais, factExtNombre, factExtConcepto ].includes(undefined) ) {
                Swal.fire("Datos para facturar al extranjero incompletos.", "Los campos marcados con [ * ] son obligatorios.", "error");
                return false;
            }
        }

        // No ha indicado ningun archivo
        if ( file.file === '' ) {
            Swal.fire("Agregar documento.", `Por favor selecciona un archivo como comprobante.`, "error");
            return false;
        }

        // Indico archivo pero no es un PDF
        const fullName = file.file.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
        if ( file.file !== '' && fileExt !== 'PDF' ) {
            Swal.fire("Documento incorrecto.", `El comprobante debe ser un archivo PDF.`, "error");
            return false;
        }

        // No ha indicado ninguna forma de pago
        if ( formaPago === '' ) {
            Swal.fire("Indicar la forma de pago.", `Los campos marcados con [ * ] son obligatorios.`, "error");
            return false;
        }

        // Importe obligatorio
        if ( importe <= 0 ) {
            Swal.fire("Indicar importe.", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        return true;
    }

    // Submit form | Boton ENVIAR 
    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log("Enviar formulario...");

        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) {
            return false;
        }

        // TODO: Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) {
                // procesar data
                continueConfirmed();
            }
        })
    }

    // Se ejecuta una sola vez al cargar la pagina
    useEffect(() => {
        
        const isUserDataLoaded = async () => {

            if (dataCDFIs.length !== 0) {
    
                const resultDataLoaded = await getOneIn({ table:'RegistrosEducon', id:id });
                // console.log("resultDataLoaded: ", resultDataLoaded);

                if (resultDataLoaded.exito === 1) {
                    const dataLoaded = resultDataLoaded.data;
                    console.log( dataLoaded );

                // El comprobante "ya fue subido"
                if (dataLoaded.compPagoFecha !== '') {
                    const day = moment(dataLoaded.compPagoFecha).format("DD");
                    const month = moment(dataLoaded.compPagoFecha).format("MM");
                    const year = moment(dataLoaded.compPagoFecha).format("YYYY");
                    Swal.fire({
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        title: "Ya existe el comprobante.",
                        text: `El documento se subió al sistema el ${day}-${month}-${year}.`,
                        footer: "Gracias por su interes en nuestro evento.",
                        showConfirmButton: false,
                        icon: 'success',
                    });
                }

                    const datosAdObj = JSON.parse(dataLoaded.datosAdicionales);
                    // console.log({datosAdObj});

                    // Establecemos los valores nuevos (fechaPago)
                    const dateNow = moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss');
                    dataLoaded.compPagoFecha = dateNow;
                    dataLoaded.compPagoURLLabel = 'Comprobante de pago';

                    setFormValues({
                        ...dataLoaded,
                        datosAdicionales: datosAdObj
                    });
                } else {
                    setFalseID(true);
                }
        
                return true;
            };
        }

        isUserDataLoaded();
    }, [dataCDFIs, id]);

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                <Box
                    sx={{
                        mt: 6,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Avatar
                        sx={{ width: 300, height: 170 }}
                        src="https://eventos.cibnor.mx/registro/educon/images/logo_posgradoCib.png"
                        variant="square"
                    />
                    <Typography variant="h5" sx={{ mt: 4, mb: 0}}>Confirmación de registro</Typography>
                    {/* Inicio del formulario */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={handleSubmit}
                        sx={{ mt: 3 }}
                        autoComplete="off"
                    >
                        {/* Contenedor general */}
                        <Grid
                            container
                            maxWidth={window.innerWidth}
                            spacing={2}
                            sx={{ pt: 2, pb: 3 }}
                        >
                            <Grid item xs={12}>
                                <Paper elevation={2}>
                                    <Card variant="outlined">
                                        <CardContent>
                                        <Grid container spacing={2}>
                                            <Grid item xs={2}>
                                                <Typography variant="h6" align="center" sx={{ p: 0 }}>Hola, </Typography>
                                            </Grid>
                                            {/* Inputs de identificacion */}
                                            <Grid item xs={10} >
                                                <TextField
                                                    id="asesorNombres"
                                                    fullWidth
                                                    value={ partNombres + " " + partApellidoPaterno }
                                                    helperText={ "<" + partCorreo + ">"}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    variant="standard"
                                                />
                                            </Grid>
                                            {/* Instrucciones */}
                                            <Grid item xs={12}>
                                                <Typography variant="h6" align="center" sx={{ p: 2 }}>Por favor agregue su comprobante de pago y confirme o actualice los datos de facturación.</Typography>
                                            </Grid>
                                            {/* Agregar comprobante */}
                                            <Grid item xs={12} >
                                                <TextField
                                                    type={"file"}
                                                    fullWidth
                                                    variant="standard"
                                                    onChange={e => setFileState(e)}
                                                    helperText="Archivo en formato PDF *"
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <SelectCustom 
                                                parentCallback={handleDetallesChange}
                                                name={"formaPago"}
                                                label={"Forma de pago"}
                                                variant={"outlined"}
                                                options={[
                                                    {value:'01', label:'Efectivo'},
                                                    {value:'02', label:'Cheque nominativo'},
                                                    {value:'03', label:'Transferencia'},
                                                    {value:'04', label:'Tarjeta de crédito'},
                                                ]}
                                                required
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField 
                                                    type={"number"}
                                                    fullWidth
                                                    inputProps={{ style: { textAlign: 'right' }}}
                                                    label="Importe *"
                                                    id="importe"
                                                    name="importe"
                                                    size="small"
                                                    value={importe}
                                                    onChange={handleDetallesChange}
                                                />
                                            </Grid>
                                            {/* Requiere factura */}
                                            {/* <Grid item xs={12} sx={{ pt: 1, pb: 1 }}>
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    alignItems="center"
                                                    sx={{ pt: 2, pb: 1 }}
                                                >
                                                    <Switch
                                                        inputProps={{ "aria-label": "ant design" }}
                                                        id={"requiereFactura"}
                                                        name={"requiereFactura"}
                                                        onChange={switchHandler}
                                                        checked={checked}
                                                    />
                                                    <Typography>Requiere factura</Typography>
                                                </Stack>
                                            </Grid> */}
                                        </Grid>





                                        {/* Requiere factura */}
                                        <GroupRequiereInvoiceGlobal 
                                            parentCallback={ handleInvoiceDataChanged }
                                        />





                                        <Slide direction="up" timeout={300} in={checked} >
                                        <Grid 
                                            container 
                                            spacing={1} 
                                            sx={{ display:(checked ? 'flex' : 'none') }} 
                                        >
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    id="factNombre"
                                                    label="Nombre completo"
                                                    name="factNombre"
                                                    onChange={handleInputChange}
                                                    required
                                                    size="small"
                                                    value={factNombre}
                                                />
                                            </Grid>
                                            <Grid item xs={8}>
                                                <TextField
                                                    fullWidth
                                                    id="factRfc"
                                                    label="RFC"
                                                    name="factRFC"
                                                    onChange={handleInputChange}
                                                    required
                                                    size="small"
                                                    value={factRFC}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    fullWidth
                                                    id="factCP"
                                                    label="C.P."
                                                    name="factCP"
                                                    onChange={handleInputChange}
                                                    required
                                                    size="small"
                                                    type="number"
                                                    value={factCP}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth required size="small">
                                                    <InputLabel id="select-usocfdi">
                                                        Uso CFDI
                                                    </InputLabel>
                                                    <Select
                                                        value={factUsoCFDI}
                                                        id="factUsoCFDI"
                                                        label="Uso CFDI"
                                                        name="factUsoCFDI"
                                                        onChange={handleInputChange}
                                                    >
                                                        {dataCDFIs.map(({ value, label }) => (
                                                            <MenuItem value={value} key={value}>
                                                                {label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <FormControl fullWidth size="small" required>
                                                    <InputLabel id="select-regimenfiscal">
                                                        Regimen fiscal
                                                    </InputLabel>
                                                    <Select
                                                        defaultValue={""}
                                                        value={factRegimenFiscal}
                                                        id="factRegimenFiscal"
                                                        label="Regimen fiscal"
                                                        name="factRegimenFiscal"
                                                        onChange={handleInputChange}
                                                    >
                                                        {dataRFs.map(({ value, label }) => (
                                                            <MenuItem value={value} key={value}>
                                                                {label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        </Slide>

                                        </CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                        
                        {/* Boton */}
                        <Paper elevation={2}>
                            <Button
                                type="submit"
                                fullWidth
                                variant="outlined"
                                endIcon={<SendIcon />}
                            >
                                Enviar
                            </Button>
                        </Paper>
                    </Box>
                </Box>
                {/* Footer */}
                <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                    <Grid item xs={12}>
                        <Divider />
                        <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                            <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                            Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                            La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                            <a href="http://www.cibnor.gob.mx/component/content/article/472" target="_blank" rel="noreferrer" >Política de privacidad</a>
                        </Typography >
                    </Grid>
                </Grid>
            </Container>
            
            {/* Dialogo de espera porque se esta enviando la informacion */}
            <Dialog 
                open={sendingForm}
                onClose={handleCloseSendingForm}
                disableEscapeKeyDown={true}
                >
                <DialogTitle id="alert-dialog-title" >
                    {"Por favor, espere..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            {/* Dialogo de en desarrollo */}
            <Dialog open={falseID} disableEscapeKeyDown={true}>
                <DialogTitle id="alert-dialog-title">
                    {"Acceso incorrecto, utilice el enlace proporcionado."}
                </DialogTitle>
                <DialogContent
                    sx={{
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                ></DialogContent>
            </Dialog>
        </ThemeProvider>
    );
};
